import { useMutation } from "@tanstack/react-query";
import { updatePassword as apiUpdatePassword } from "../../api/apiProfile";
import { toast } from "react-hot-toast";
import getErrorMessageFromAxiosError from "../../utils/parseError";

/**
 * Hook لتغيير كلمة المرور
 */
export function useUpdatePassword() {
    const {
        mutate: updatePassword,
        isPending: isUpdating,
        error,
    } = useMutation({
        mutationFn: (req) => apiUpdatePassword(req),
        onSuccess: (response) => {
            toast.success(response.message || 'Password updated successfully');
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Failed to update password");
            toast.error(msg);
        },
    });

    return { updatePassword, isUpdating, error };
}
